// Lightweight sound utility for task completion notifications
// Generates a short ding using the Web Audio API to avoid bundling audio assets

let cachedAudioContext = null;

export function playCompletionSound() {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) {
      return;
    }

    if (!cachedAudioContext) {
      cachedAudioContext = new AudioCtx();
    }

    const ctx = cachedAudioContext;
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }

    const now = ctx.currentTime;
    const baseVolume = 0.08;

    const notes = [
      { freq: 880, duration: 0.12 },
      { freq: 1318.51, duration: 0.2 }
    ];

    let t = now;
    for (const { freq, duration } of notes) {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();

      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(freq, t);

      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(baseVolume, t + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);

      oscillator.connect(gain);
      gain.connect(ctx.destination);

      oscillator.start(t);
      oscillator.stop(t + duration + 0.02);

      t += duration + 0.04;
    }
  } catch (_) {
    // Best-effort only
  }
}


